import React from 'react';
import Fold from '../Fold';
import styles from './styles.scss';

function FoldStartup() {
  return (
    <Fold bgStyle="#FFF" top={0}>
      <div className={styles.foldBox}>
        <h1 className={`${styles.heading} bold extra-bold`}>
          Thinking of launching a startup?
        </h1>
        <h2 className={`${styles.subHeading} mt50 alt-text`}>
          Turn your idea into a prototype in 30 days.
        </h2>
      </div>
      <p className="lsh demi-bold alt-text text-center mt200">
        We've all had this moment...
      </p>
      <h1 className="bold text-center">
        "I’ve got this idea I have to try!"
      </h1>
    </Fold>
  );
}

export default FoldStartup;



// WEBPACK FOOTER //
// ./src/components/StartupFold/index.js